import * as React from 'react'
import styled from 'styled-components'

import { t } from '@ulule/localize'
import * as plume from '@ulule/owl-kit-components/next'

export function Title(): React.ReactElement<unknown> {
  return (
    <Wrapper>
      <plume.styles.heading.S>{t('Be among the first to support this project 👇')}</plume.styles.heading.S>
      <plume.styles.heading.L>{t('Be among the first to support this project 👇')}</plume.styles.heading.L>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  text-align: center;

  ${plume.styles.heading.L} {
    display: none;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.styles.heading.S} {
      display: none;
    }

    ${plume.styles.heading.L} {
      display: block;
      margin-bottom: 25px;
    }
  }
`
